import Wallpaper from "./Wallpaper";
export default Wallpaper;
